import { gql } from '@apollo/client'

export const Query = gql`
  query MystroTests($companyId: ID!) {
    mystroTests(companyId: $companyId) {
      id
      name
      equipmentCount
      equipmentTypesCount
      equipmentCategoriesCount
    }
  }
`
